import React from 'react';
import { TBusinessBoxFormProps } from '../BusinessBoxCreate/types';
import { useTranslation } from 'react-i18next';
import { Button } from '@infologistics/frontend-libraries';
import { BusinessBoxInput } from '../BusinessBoxInput/BusinessBoxInput';
import cn from 'classnames';
import styles from './styles.module.scss';

export const BusinessBoxForm = <T extends object>(
  props: TBusinessBoxFormProps<T>
) => {
  const { t } = useTranslation();
  const { formikProps, onCloseModal, onDeleteClick, fields, updateForm } =
    props;

  const FIELDS = fields.map((val) => ({
    ...val,
    wrapperClasses: updateForm ? styles.settings__wrapper : val.wrapperClasses,
    itemClasses: updateForm ? styles.settings__item + ' mb-4' : undefined,
    labelClasses: updateForm ? styles.settings__label : undefined,
  }));

  const renderInputs = () =>
    FIELDS.map((val) => BusinessBoxInput(val, formikProps, t));

  return (
    <form noValidate onSubmit={formikProps.handleSubmit}>
      <div
        className={cn({ 'modal-body grid-8 grid-gutters-xl': !!onCloseModal })}
      >
        {renderInputs()}
      </div>

      <footer
        className={cn('d-flex', {
          'modal-footer my-0 px-4 py-3': !!onCloseModal,
        })}
      >
        {onDeleteClick && (
          <Button theme='default' type='button' onClick={onDeleteClick}>
            {t('common:delete')}
          </Button>
        )}
        <Button theme='primary' type='submit' externalClass='ml-auto'>
          {t('common:save')}
        </Button>
        {onCloseModal && (
          <Button externalClass={'ml-4'} onClick={onCloseModal}>
            {t('common:close')}
          </Button>
        )}
      </footer>
    </form>
  );
};
